import store from '@/store'
import { signRequest } from './authorization'

const onSuccess = (response) => {
  store.dispatch('loader/setLoading', false)
  return response
}

const onError = (error) => {
  store.dispatch('loader/setLoading', false)
  return Promise.reject(error)
}

const beforeRequestSuccess = (config) => {
  signRequest(config)
  store.dispatch('loader/setLoading', true)
  return config
}

const beforeRequestError = (error) => {
  store.dispatch('loader/setLoading', false)
  return Promise.reject(error)
}

export { onSuccess, onError, beforeRequestSuccess, beforeRequestError }



// WEBPACK FOOTER //
// ./src/api/competitor/interceptors.js